import type { CalendarEvent } from '../types';

const DEFAULT_TYPE_ROUTES: Record<CalendarEvent['type'], string> = {
  exam: '/admit-cards',
  admit_card: '/admit-cards',
  result: '/results',
  deadline: '/opportunities',
  counselling: '/results',
  dv: '/results',
  interview: '/results',
  joining: '/results',
};

export function formatCalendarEventType(type: CalendarEvent['type']): string {
  return type.replace(/_/g, ' ');
}

export function calendarEventRoute(
  event: CalendarEvent,
  typeRoutes?: Record<string, string>,
): string {
  const routes = { ...DEFAULT_TYPE_ROUTES, ...typeRoutes };
  const base = routes[event.type] || '/results';

  if (event.type === 'result' && event.examId) {
    return `/results/${encodeURIComponent(event.examId)}`;
  }

  if ((event.type === 'exam' || event.type === 'admit_card') && event.title) {
    return `${base}?q=${encodeURIComponent(event.title)}`;
  }

  return base;
}
